import { useState } from 'react';
import { UMIcon, UMR } from '../_components';
import type { UMToolSpec } from '../_components';

/**
 * Piste G3: the editing tools do not sit in the top bar. They appear in a floating bar over the
 * map, centred under the toolbar, as soon as a building is drawn or selected — the condition the
 * production panel already states ("Pour activer plus d'options, dessinez un bâtiment").
 */

function EditButton({ tool, active, onClick }: { tool: UMToolSpec; active: boolean; onClick: () => void }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        height: 32, display: 'flex', alignItems: 'center', gap: 6, padding: '0 10px', border: 'none',
        background: active ? UMR.blue : hover ? UMR.hover : 'transparent', color: active ? UMR.white : UMR.black,
        fontFamily: UMR.font, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap',
      }}
    >
      <UMIcon name={tool.icon} size={20} color={active ? UMR.white : UMR.black} style={{ height: 24 }} />
      {tool.label}
    </button>
  );
}

export function GeometryEditBar({ tools, activeTool, onToolChange }: { tools: UMToolSpec[]; activeTool: string | null; onToolChange: (id: string | null) => void }) {
  return (
    <div
      role="toolbar"
      aria-label="Modifier le bâtiment sélectionné"
      style={{
        position: 'absolute', top: UMR.size.toolbarHeight + UMR.size.controlsInset, left: '50%', transform: 'translateX(-50%)', zIndex: 20,
        display: 'flex', alignItems: 'center', gap: 2, padding: 4, background: UMR.white,
        border: `1px solid ${UMR.border}`, boxShadow: 'rgba(0,0,0,0.1) 0 2px 8px', fontFamily: UMR.font,
      }}
    >
      {tools.map((t) => (
        <EditButton key={t.id} tool={t} active={activeTool === t.id} onClick={() => onToolChange(activeTool === t.id ? null : t.id)} />
      ))}
    </div>
  );
}
